import { useModal } from '@/components/ModalContext';
import { request } from '@/functions/data-access';
import { useBooleanState } from '@/hooks/useBooleanState';
import useHintModals from '@/hooks/useHintModals.tsx';
import { getErrorMessage } from '@/shared/utils/error';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/sharp-solid-svg-icons';
import { Labels, Messages } from '@lib/sc-eone-ui/src/strings/strings-en-us';
import { FormCheckbox } from 'eone-ui/forms/form-checkbox';
import { FormString } from 'eone-ui/forms/form-string';
import { FormText } from 'eone-ui/forms/form-text';
import { getDataTestId } from 'eone-ui/functions/data-test-ids';
import { Sidebar } from 'eone-ui/sidebar/sidebar';
import { useEffect, useState } from 'react';
import './help-sidebar.css';

function HelpEmail(props) {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [diagnostics, setDiagnostics, toggleDiagnostics] = useBooleanState(false);
  const [sent, setSent] = useState(false);
  const [isDisbled, setIsDisbled] = useState(false);
  const { showErrorModal } = useHintModals();
  const { hideLoadingOverlay, showLoadingOverlay } = useModal();

  const getDiagnosticInfo = () => {
    return {
      UserAgent: navigator.userAgent,
      Language: navigator.language,
      Path: window.location.pathname,
      Search: window.location.search,
    };
  };

  const getEmail = () => {
    const email: any = {
      Subject: subject,
      Message: message,
    };
    console.log('diagnostics =', diagnostics);
    if (diagnostics) email.Diagnostics = getDiagnosticInfo();
    else email.Diagnostics = null;

    return email;
  };

  // const send = () => {
  //   const xhr = new XMLHttpRequest();
  //   //xhr.open('post', '/Zendesk/CreateTicket', true);
  //   xhr.open("post", "/Help/SendEmail", true);
  //   xhr.send(JSON.stringify(getEmail()));
  //   setSent(true);
  //   // note - doing this for git commit error
  //   setDiagnostics(!diagnostics);
  // };

  const send = async () => {
    try {
      showLoadingOverlay();
      await request({ url: '/help/sendemail', data: getEmail(), method: 'POST' });
      setSent(true);
      if (diagnostics) setDiagnostics(!diagnostics);
    } catch (error) {
      await showErrorModal({
        Error: {
          description: getErrorMessage(error),
        },
        Title: 'Help email send error',
      });
    } finally {
      hideLoadingOverlay();
    }
  };

  useEffect(() => {
    setIsDisbled(!(subject != null && subject != '' && message != null && message != ''));
  }, [subject, message]);

  if (sent) {
    return <HelpEmailSent />;
  }

  return (
    <div className="pd-email-sidebar-container">
      <div className="pd-email-sidebar-fields">
        <FormString
          Label={Labels.Subject}
          Value={subject}
          OnChange={setSubject}
          DataTestId={getDataTestId(props.DataTestId, 'subject')}
        />
        <FormText
          Label={Labels.Message}
          Height="calc(100svh - 500px)"
          Resize="vertical"
          Value={message}
          OnChange={setMessage}
          DataTestId={getDataTestId(props.DataTestId, 'message')}
        />
        <FormCheckbox
          Label={Labels.IncludeDiagnostics}
          Value={diagnostics}
          OnChange={toggleDiagnostics}
          DataTestId={getDataTestId(props.DataTestId, 'include-diagnostics')}
        />
      </div>
      <HelpEmailButton
        Disabled={isDisbled}
        Send={send}
        DataTestId={getDataTestId(props.DataTestId, 'send')}
      />
    </div>
  );
}

function HelpEmailButton(props) {
  const send = () => {
    if (typeof props.Send === 'function') {
      props.Send();
    }
  };

  if (props.Disabled) {
    return (
      <a className="pd-send-email-btn-disabled" data-testid={props.DataTestId}>
        <FontAwesomeIcon icon={faPaperPlane} fixedWidth />
        <label>{Labels.SendEmail}</label>
      </a>
    );
  } else
    return (
      <a className="pd-send-email-btn cursor" onClick={send} data-testid={props.DataTestId}>
        <FontAwesomeIcon icon={faPaperPlane} fixedWidth />
        <label>{Labels.SendEmail}</label>
      </a>
    );
}

function HelpEmailSent(props) {
  return (
    <div style={{ padding: 15 }}>
      <label data-testid={getDataTestId(props.DataTestId, 'sent')}>{Messages.EmailSent}</label>
    </div>
  );
}

function Email(props) {
  if (!props.Open) {
    return null;
  }
  return (
    <Sidebar HeaderTitle={Labels.SendUsAnEmail} Close={props.OnClose} DataTestId="email-header">
      <HelpEmail DataTestId="email-body" />
    </Sidebar>
  );
}

export { Email };
